import type { BankTransactionBase } from '@api/models';
import { BankTransactionQueryParams } from '@api/query';
import type { ComputedRef } from 'vue';

import { stuut } from '@/api';

import { computeEffectiveParams, useResourceNavigation } from './useResourceNavigation';
import type { UseResourceNavigationReturn } from './useResourceNavigation';

export interface UseBankTransactionNavigationOptions {
  params?: ComputedRef<BankTransactionQueryParams | null>;
}

export function useBankTransactionNavigation(
  transactionId: ComputedRef<string>,
  options: UseBankTransactionNavigationOptions,
): UseResourceNavigationReturn {
  const effectiveParams = computeEffectiveParams<BankTransactionQueryParams>(
    options.params,
    BankTransactionQueryParams,
    {
      include_withdrawals: true,
      sortBy: 'timestamp',
      sortOrder: 'desc',
    },
  );

  return useResourceNavigation<BankTransactionBase, BankTransactionQueryParams>(transactionId, {
    fetchList: (params) => stuut.bankTransactions.list({ params }, true),
    detailRouteName: 'cash-app.transactions.transaction',
    params: effectiveParams,
    queryKeyPrefix: 'bank-transactions',
    paramsClass: BankTransactionQueryParams,
  });
}
